// extracted by mini-css-extract-plugin
module.exports = {"block":"big_block__k25Oy","content":"big_content__MibW2","smallImage":"big_smallImage__nRGXp","bigImage":"big_bigImage__7ZKbv","bigImage--reverse":"big_bigImage--reverse__98L_M"};